import * as Yup from 'yup';

export interface IMcqQuestionFormInput {
  evaluation_id: number;
  question_title: string;
  option_a: string;
  option_b: string;
  option_c: string;
  option_d: string;
  correct_option: 'A' | 'B' | 'C' | 'D';
  marks: number;
  display_order: number;
  id: number;
}

export const McqQuestionInitialValues: IMcqQuestionFormInput = {
  evaluation_id: 0,
  id: 0,
  question_title: '',
  option_a: '',
  option_b: '',
  option_c: '',
  option_d: '',
  correct_option: 'A',
  marks: 1,
  display_order: 1
};

export const McqQuestionSchemaValidation = Yup.object().shape({
  evaluation_id: Yup.number()
    .min(0, 'Evaluation ID must be valid')
    .required('Evaluation ID is required'),

  question_title: Yup.string()
    .trim()
    .min(5, 'Question must be at least 5 characters long')
    .max(500, 'Question is too long')
    .required('Question title is required'),

  option_a: Yup.string().trim().min(1, 'Option A cannot be empty').required('Option A is required'),

  option_b: Yup.string().trim().min(1, 'Option B cannot be empty').required('Option B is required'),

  option_c: Yup.string().trim().min(1, 'Option C cannot be empty').required('Option C is required'),

  option_d: Yup.string().trim().min(1, 'Option D cannot be empty').required('Option D is required'),

  correct_option: Yup.mixed<'A' | 'B' | 'C' | 'D'>()
    .oneOf(['A', 'B', 'C', 'D'], 'Please select a valid correct option')
    .required('Correct option is required'),

  marks: Yup.number()
    .min(0, 'Marks cannot be negative')
    .integer('Marks must be a whole number')
    .required('Marks are required'),

  display_order: Yup.number()
    .min(1, 'Display order must be at least 1')
    .integer('Display order must be a whole number')
    .required('Display order is required')
});
